export function IconImport(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg 
      {...props}
      width={props.width ? props.width : "33"} 
      height={props.height ? props.height : "33"} 
      viewBox="0 0 33 33" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M18.1947 25.5234L9.90137 15.1676H16.1136C16.8541 6.66875 23.9834 0 32.6748 0C32.7841 0 32.8914 0.0061875 33 0.00825C25.8081 1.50837 20.3328 7.65669 19.8337 15.1676H26.4021L18.1947 25.5234Z" 
        fill={props.color ? props.color : "#F4F4F6"} />
      <path 
        d="M30.25 3.4375V5.5V13.222V13.7926V17.0713V18.7344V30.25H2.75V2.75H14.4375H16.5H19.1208C19.1208 2.75 21.9574 0.81675 24.0625 0H19.4796H14.4375H0V33H33V18.7344V15.0679V13.7933V11.0433V5.5V1.98481C32.7711 2.03225 32.5504 2.10031 32.3256 2.15806C30.9334 2.60631 30.25 3.4375 30.25 3.4375Z" 
        fill={props.color ? props.color : "#F4F4F6"} />
    </svg>

  );
}
